import React from "react";
import {
  FaHandsHelping,
  FaBullhorn,
  FaTree,
  FaGraduationCap,
  FaFemale,
  FaShieldAlt,
  FaBriefcase,
  FaCity,
} from "react-icons/fa";

const ProgramsSection = () => {
  const programs = [
    { icon: FaHandsHelping, title: "Aabharan Shakti" },
    { icon: FaBullhorn, title: "Jagriti Darpan" },
    { icon: FaTree, title: "Ankuran Bandhan" },
    { icon: FaGraduationCap, title: "Yuva Utkarsh" },
  ];

  const projects = [
    { icon: FaFemale, name: "Project Kishori" },
    { icon: FaShieldAlt, name: "Project Rakshak" },
    { icon: FaBriefcase, name: "Project Setu" },
    { icon: FaCity, name: "Project Nagrik" },
  ];

  return (
    <section className="relative bg-gradient-to-br from-[#eafaff] via-white to-[#dff7fb] py-16 overflow-hidden">
      <div className="absolute top-20 left-10 w-72 h-72 bg-[#1298b5]/20 rounded-full mix-blend-multiply filter blur-3xl animate-blob"></div>
      <div className="absolute bottom-20 right-10 w-72 h-72 bg-[#f97316]/20 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fadeInDown">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-[#1298b5] to-[#0b819b] rounded-2xl text-white mb-5 shadow-lg">
            <FaGraduationCap className="text-3xl" />
          </div>

          <h2 className="text-4xl md:text-6xl font-extrabold text-[#073b4c] mb-3">
            Our <span className="text-[#1298b5]">Programs</span>
          </h2>

          <div className="w-24 h-1 bg-gradient-to-r from-[#1298b5] to-[#f97316] mx-auto rounded-full mb-5"></div>

          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Aabharan Foundation runs several impactful initiatives. Here's an
            overview.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12 animate-fadeInUp">
          {programs.map((program, idx) => {
            const Icon = program.icon;

            return (
              <div
                key={idx}
                className="group bg-white/90 backdrop-blur-sm rounded-3xl shadow-lg p-7 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-[#d8f4f8] hover:border-[#1298b5]/50 text-center"
              >
                <div className="w-16 h-16 mx-auto bg-[#eafaff] rounded-2xl flex items-center justify-center text-[#1298b5] text-3xl mb-5 group-hover:bg-[#1298b5] group-hover:text-white transition-all duration-300">
                  <Icon />
                </div>

                <h3 className="text-xl font-bold text-[#073b4c]">
                  {program.title}
                </h3>

                <div className="h-1 w-14 bg-gradient-to-r from-[#1298b5] to-[#f97316] rounded-full mt-5 mx-auto"></div>
              </div>
            );
          })}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 animate-fadeInUp animation-delay-300">
          {projects.map((proj, i) => {
            const Icon = proj.icon;

            return (
              <div
                key={i}
                className="group bg-white/90 backdrop-blur-sm rounded-2xl p-5 text-[#073b4c] flex items-center gap-3 hover:shadow-lg transition-all duration-300 border border-[#d8f4f8] hover:border-[#1298b5]/50 hover:-translate-y-1"
              >
                <div className="w-11 h-11 bg-[#eafaff] rounded-xl flex items-center justify-center text-[#1298b5] flex-shrink-0 group-hover:bg-[#f97316] group-hover:text-white transition-all duration-300">
                  <Icon className="text-lg" />
                </div>

                <h4 className="font-bold text-[#073b4c]">{proj.name}</h4>
              </div>
            );
          })}
        </div>
      </div>

      <style>{`
        @keyframes blob {
          0% { transform: translate(0px, 0px) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.08); }
          66% { transform: translate(-20px, 20px) scale(0.95); }
          100% { transform: translate(0px, 0px) scale(1); }
        }

        .animate-blob {
          animation: blob 7s infinite;
        }

        .animation-delay-2000 {
          animation-delay: 2s;
        }

        .animation-delay-300 {
          animation-delay: 0.3s;
        }

        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .animate-fadeInDown {
          animation: fadeInDown 0.8s ease-out forwards;
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease-out forwards;
        }
      `}</style>
    </section>
  );
};

export default ProgramsSection;